import { render, staticRenderFns } from "./TableSection.vue?vue&type=template&id=47e18403"
import script from "./TableSection.vue?vue&type=script&lang=js"
export * from "./TableSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports